export default __webpack_public_path__ + "static/media/pic4.831ec23f.jpg";